import gql from "graphql-tag";
import { toast } from "react-toastify";
import { sentryWrappedException } from "~/utils/Utils";
import getQuery from "../utils/get_query";

export default async function confirmOptInPortfolioParcision(
  pid: number,
  phash: string,
  pverified: boolean,
  rhash: string,
  rverified: boolean,
  description: string
) {
  try {
    const variables = {
      pid,
      phash,
      pverified,
      rhash,
      rverified,
      description,
    };

    const query = gql`
      query MyQuery(
        $pid: Float!
        $phash: String!
        $pverified: Boolean!
        $rhash: String!
        $rverified: Boolean!
        $description: String!
      ) {
        optInPortfolioParcision(
          pid: $pid
          phash: $phash
          pverified: $pverified
          rhash: $rhash
          rverified: $rverified
          description: $description
        ) {
          message
        }
      }
    `;

    const data = await getQuery(query, variables);
    // @ts-expect-error
    return data.optInPortfolioParcision;
  } catch (error) {
    toast.error("Failed to confirm bid");
    sentryWrappedException(error);
    throw error;
  }
}
